import { useApiPost } from '@sierralabs/core-ui';
export function useCreateEntity() {
    const { data, isLoading, error, post } = useApiPost('entities');
    return {
        createdEntity: data,
        isCreating: isLoading,
        error,
        createEntity: post
    };
}
//# sourceMappingURL=useCreateEntity.js.map